import { useShallowEqualSelector } from "../../_helpers/redux";
import { Modal } from "antd";
import React, { useContext } from "react";
import TagsTable from "./TagsTable";
import AddTagForm from "./AddTagForm";
import { useDispatch } from "react-redux";
import { clinicianActions } from "../../../state/models/clinicians";
import { isCfaFeatureFlagEnabled, useUserHasAnyPermissions } from "@/app/_helpers/permissions";
import { CurrentConfigContext } from "@/app/app.utils";

export default () => {
  const config = useContext(CurrentConfigContext);
  const useV4Tags = !!isCfaFeatureFlagEnabled("v4TeamTabTags", config);

  const [tagModalClinicianId, clinician] = useShallowEqualSelector((state) => {
    const tagModalClinicianId = state.clinicians.tagModalClinicianId;
    return [
      tagModalClinicianId,
      tagModalClinicianId === null
        ? null
        : state.clinicians.clinicianMap[tagModalClinicianId],
    ];
  });
  const userCanSeeAddTagForm = useUserHasAnyPermissions([
    "IsClinicalLeader",
    "IsMatchingAdmin",
    "IsSuperUser",
  ]);

  const dispatch = useDispatch();

  const clinicianName =
    clinician === null
      ? ""
      : `- ${clinician.first_name} ${clinician.last_name}`;

  return (
    <Modal
      {...{
        title: `Matchmaker Tags ${clinicianName}`,
        open: tagModalClinicianId !== null,
        width: "900px",
        onCancel: () => dispatch(clinicianActions.setTagModalClinicianId(null)),
        footer: null,
        style: { top: "45px" },
        bodyStyle: { paddingBottom: "5px" },
      }}
    >
      {tagModalClinicianId !== null && (
        <>
          {userCanSeeAddTagForm ? (
            <AddTagForm clinicianId={tagModalClinicianId} useV4Tags={useV4Tags} />
          ) : null}
          <TagsTable clinicianId={tagModalClinicianId} useV4Tags={useV4Tags} />
        </>
      )}
    </Modal>
  );
};
